import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface FormNavPanelProps {
  value: number;
  selectedValue: number;
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
}

const VerticalTabPanel = ({ value, selectedValue, children, sx }: FormNavPanelProps) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== selectedValue}
      id={`vertical-tabpanel-${value}`}
      aria-labelledby={`vertical-tab-${value}`}
    >
      <Box sx={[{ pl: 3 }, ...(Array.isArray(sx) ? sx : [sx])]}>{children}</Box>
    </div>
  );
};

export default VerticalTabPanel;
